export const isValidUrl = (string: string): boolean => {
  try {
    const url = new URL(string);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};

export const isRedundantVisaDescription = (
  description: string | undefined,
  visaType?: string
): boolean => {
  if (!description) return false;
  const d = description.trim().toLowerCase();
  if (!d) return false;
  if (visaType === 'visa-free') {
    return d === '免签' || d === 'visa-free' || d === 'visa free';
  }
  if (visaType === 'visa-on-arrival') {
    return d === '落地签' || d === 'visa-on-arrival' || d === 'visa on arrival';
  }
  if (visaType === 'visa-required') {
    return d === '需要签证' || d === 'visa required';
  }
  return false;
};

/** 已有「申根区」标签时，去掉描述里重复的「申根签」等字样 */
export function getVisaDescriptionForDisplay(
  description: string | undefined,
  visaType?: string,
  schengen?: boolean
): string | undefined {
  if (!description) return undefined;
  if (isRedundantVisaDescription(description, visaType)) return undefined;

  let text = description.trim();
  if (!text) return undefined;

  if (schengen) {
    if (text === '申根签') return undefined;
    text = text.replace(/申根签/g, '签').trim();
  }

  return text || undefined;
}
